import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const UnderConstruction = () => {
  const navigate = useNavigate();
  const [isAnimating, setIsAnimating] = useState(false);

  // Animation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => setIsAnimating(false), 1000);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Update page title
  useEffect(() => {
    document.title = "Under Construction | Our Website";
  }, []);

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Header */}
      <div className="fixed top-0 left-0 w-full z-50 bg-primary">
        <Header />
      </div>

      {/* Main Layout */}
      <div className="flex flex-1 mt-[72px]">
        {/* Sidebar */}
        <div className="fixed left-0 w-64 bg-white shadow-sm h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
          <Sidebar />
        </div>

        {/* Main Content */}
        <main className="flex-1 p-6 overflow-y-auto mt-[25px] lg:ml-64 flex items-center justify-center">
          <div className="w-full max-w-md">
            <div className="bg-white p-8 rounded-xl shadow-sm text-center border border-gray-100">
              {/* Animated Construction Icon */}
              <div className={`text-6xl mb-6 transition-all duration-500 ${isAnimating ? "scale-110" : "scale-100"}`}>
                🚧
              </div>

              {/* Heading */}
              <h1 className="text-3xl font-bold text-gray-800 mb-3">
                We're Building Something Awesome
              </h1>
              <p className="text-gray-600 mb-6">
                Our team is working hard to create an amazing experience for you.
              </p>

              {/* Divider */}
              <div className="relative my-6">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-200"></div>
                </div>
                <div className="relative flex justify-center">
                  <span className="px-2 bg-white text-sm text-gray-500">
                    Coming Soon
                  </span>
                </div>
              </div>

              {/* Progress indicator */}
              <div className="mb-6">
                <div className="w-full bg-gray-200 rounded-full h-2.5 mb-3">
                  <div 
                    className={`bg-primary h-2.5 rounded-full ${isAnimating ? "w-3/4" : "w-2/3"}`}
                    style={{ transition: "width 1s ease-in-out" }}
                  ></div>
                </div>
                <p className="text-sm text-gray-500">
                  Working diligently to bring you the best
                </p>
              </div>

              {/* Actions */}
              <div className="flex flex-col space-y-3">
                <button
                  onClick={() => navigate("/")}
                  className="px-4 py-2.5 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors font-medium"
                >
                  Go Back Home
                </button>
               
              </div>
            </div>

            {/* Footer */}
            <div className="mt-8 text-center text-gray-500 text-sm">
              <p>© {new Date().getFullYear()} TribeVue®. All rights reserved.</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default UnderConstruction;